module.exports = __webpack_public_path__ + "static/media/CetraRudy_STORY_2_30fps_vimeo.1f059822.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/vids/CetraRudy_STORY_2_30fps_vimeo.mp4
// module id = 147
// module chunks = 0